namespace RecordShield.Modules.Workspace.Products {
    export interface ProductCodeRequest extends Serenity.ServiceRequest {
    }
}
